import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from "@mui/material";
import Chart from 'react-apexcharts';

function DonutChartMultiStepTime(props) {
    const toValidNumber = (value) => {
        const num = Number(value);
        return isNaN(num) ? 0 : num;
    };

    const act = toValidNumber(props.act);
    const diff = toValidNumber(props.diff);

    const seriesData = useMemo(() => [act === 0 && diff > 0 ? 0.000001 : act, diff], [act, diff]);

    const total = useMemo(() => seriesData.reduce((acc, val) => acc + val, 0), [seriesData]);

    const options = useMemo(() => ({
        chart: {
            type: 'donut',
            offsetY: 0,
            parentHeightOffset: 0,
            toolbar: { show: false },
            zoom: { enabled: false }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 100
                },
                legend: {
                    position: 'bottom'
                }
            }
        }],
        plotOptions: {
            pie: {
                expandOnClick: false,
                donut: {
                    size: "80%",
                    labels: {
                        show: false,
                        total: {
                            show: true,
                            label: 'Total',
                            formatter: () => total
                        }
                    }
                }
            }
        },
        stroke: {
            width: 0.5,
            colors: ['#575959']
        },
        colors: ['#0cc694', 'transparent'], // <== เปลี่ยนจาก transparent
        dataLabels: {
            enabled: false,
            formatter: (val, opts) => seriesData[opts.seriesIndex],
        },
        legend: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
        fill: {
            type: 'solid', // <== ไม่ใช้ gradient แล้ว
        },
    }), [seriesData, total]);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', width: '100%', height: '100%' }}>
            <Chart
                options={options}
                series={seriesData}
                type="donut"
                width="120%"
                height="120%"
            />
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                color: '#fff',
                fontFamily: 'CPF_Imm_Sook',
                maxHeight: '40%',
            }}>
                <div style={{ fontSize: 'clamp(12px, 2vw, 20px)', lineHeight: '1' }}>{props.step}</div>
                <div style={{ fontSize: 'clamp(28px, 3vw, 36px)', fontWeight: 'bold', lineHeight: '1.2', margin: '0px 0' }}>{props.time}</div>
                <div style={{ fontSize: 'clamp(12px, 2vw, 16px)', lineHeight: '1' }}>{props.mins}</div>
            </Box>
        </Box>
    );
}

DonutChartMultiStepTime.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default DonutChartMultiStepTime;
